<template>
  <div id="LoginPage">
    <div class="flex flex-col justify-center">
      <!-- If you are digging through this, you should probably stop and work for us :) -->
      <img
        alt="login"
        class="mb-6"
        width="175px"
        draggable="false"
        src="https://connect-cdn.intellectualpoint.com/assets/images/logos/IntellectualPoint.png"
      />
    </div>
    <div v-if="currentStep === 'EMAIL'">
      <div class="flex flex-col justify-center">
        <h1 class="mb-2 font-bold">Welcome to Learn</h1>
        <p class="font-light">Please sign in using your email</p>
      </div>
      <vs-input
        v-model="email"
        v-validate="'required|min:3'"
        class="w-full bg-light mt-10"
        data-vv-validate-on="blur"
        icon="icon icon-user"
        icon-no-border
        icon-pack="feather"
        label-placeholder="Email"
        name="email"
        color="white"
        v-on:keyup.enter="checkLoginMethods"
      />
      <span class="text-danger text-sm font-bold">{{ errors.first('email') }}</span>

      <div class="flex flex-wrap justify-end mt-10">
        <vs-button :disabled="!validateEmail || disable" @click="checkLoginMethods" type="border" color="primary" id="signInBtn"
          >Next</vs-button
        >
      </div>
    </div>
    <div v-if="currentStep === 'METHOD'">
      <div class="flex flex-col justify-center">
        <h1 class="mb-2 font-bold">Choose Sign In Method</h1>
        <div class="flex items-center gap-2 mb-6">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-5 w-5 cursor-pointer" @click="currentStep = 'EMAIL'" />
          <p>{{ email }}</p>
        </div>

        <div
          class="vx-card p-4 mb-4 cursor-pointer card-hover-mode"
          v-if="loginMethods.includes('EMAIL')"
          @click="createLoginRequest('EMAIL')"
        >
          <div class="flex justify-between items-center">
            <div class="flex items-center gap-5">
              <feather-icon icon="MailIcon" svgClasses="h-8 w-8 ml-1" />
              <div>
                <h3>Email</h3>
                Recieve a one-time code sent to your email
              </div>
            </div>
          </div>
        </div>

        <div
          class="vx-card p-4 mb-4 cursor-pointer card-hover-mode"
          v-if="loginMethods.includes('PHONE')"
          @click="createLoginRequest('PHONE')"
        >
          <div class="flex justify-between items-center">
            <div class="flex items-center gap-5">
              <feather-icon icon="PhoneIcon" svgClasses="h-8 w-8 ml-1" />
              <div>
                <h3>Phone</h3>
                Recieve a one-time code sent to your phone
              </div>
            </div>
          </div>
        </div>

        <div
          class="vx-card p-4 mb-4 cursor-pointer card-hover-mode"
          v-if="loginMethods.includes('PASSWORD')"
          @click="createLoginRequest('PASSWORD')"
        >
          <div class="flex justify-between items-center">
            <div class="flex items-center gap-5">
              <feather-icon icon="KeyIcon" svgClasses="h-8 w-8 ml-1" />
              <div>
                <h3>Password</h3>
                Use your account password to sign in
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentStep === 'CHALLENGE_PASSWORD'">
      <h1 class="mb-2 font-bold">Enter Your Password</h1>
      <div class="flex items-center gap-2 mb-6">
        <feather-icon
          icon="ArrowLeftCircleIcon"
          svgClasses="h-5 w-5 cursor-pointer"
          @click="
            currentStep = 'EMAIL';
            loginToken = '';
            password = '';
          "
        />
        <p>{{ email }}</p>
      </div>
      <vs-input
        v-model="password"
        v-validate="'required|min:6'"
        class="w-full bg-light mt-10"
        data-vv-validate-on="blur"
        icon="icon icon-lock"
        icon-no-border
        icon-pack="feather"
        label-placeholder="Password"
        name="password"
        type="password"
        color="white"
        @keyup.enter="submitLoginRequest"
      />
      <span class="text-danger text-sm font-bold">{{ errors.first('password') }}</span>

      <div class="flex flex-wrap justify-end mt-10">
        <vs-button :disabled="!validatePassword || disable" @click="submitLoginRequest" type="border" color="primary">Sign In</vs-button>
      </div>
    </div>
    <div v-if="currentStep === 'CHALLENGE_PHONE'">
      <h1 class="font-bold">Check Your Phone</h1>
      <p class="mb-2 font-light">Enter the 6 digit code sent to your phone number.</p>
      <div class="flex items-center gap-2 mb-6">
        <feather-icon
          icon="ArrowLeftCircleIcon"
          svgClasses="h-5 w-5 cursor-pointer"
          @click="
            currentStep = 'EMAIL';
            loginToken = '';
            password = '';
          "
        />
        <p>{{ email }}</p>
      </div>
      <otp-input
        ref="otpInputPhone"
        input-classes="otp-input"
        class="otp-input-box gap-2 sm:gap-4"
        separator="-"
        :num-inputs="6"
        :should-auto-focus="true"
        :is-input-num="true"
        @on-complete="submitLoginRequest"
        :key="otpKey"
      />
    </div>
    <div v-if="currentStep === 'CHALLENGE_EMAIL'">
      <h1 class="font-bold">Check Your Email</h1>
      <p class="mb-2 font-light">Enter the 6 digit code sent to your email.</p>
      <div class="flex items-center gap-2 mb-6">
        <feather-icon
          icon="ArrowLeftCircleIcon"
          svgClasses="h-5 w-5 cursor-pointer"
          @click="
            currentStep = 'EMAIL';
            loginToken = '';
            password = '';
          "
        />
        <p>{{ email }}</p>
      </div>
      <otp-input
        ref="otpInputEmail"
        input-classes="otp-input"
        class="otp-input-box gap-2 sm:gap-4"
        separator="-"
        :num-inputs="6"
        :should-auto-focus="true"
        :is-input-num="true"
        @on-complete="submitLoginRequest"
        :key="otpKey"
      />
    </div>
    <div v-if="currentStep === 'CHALLENGE_SMART'">
      <div v-if="smartStep === 'PHONE'">
        <h1 class="font-bold">Check Your Phone</h1>
        <p class="mb-2 font-light">Enter the 6 digit code sent to your phone number.</p>
        <div class="flex items-center gap-2 mb-6">
          <feather-icon
            icon="ArrowLeftCircleIcon"
            svgClasses="h-5 w-5 cursor-pointer"
            @click="
              currentStep = 'EMAIL';
              smartStep = 'PHONE';
              loginToken = '';
              password = '';
            "
          />
          <p>{{ email }}</p>
        </div>
        <otp-input
          ref="otpInputSmartPhone"
          input-classes="otp-input"
          class="otp-input-box gap-2 sm:gap-4"
          separator="-"
          :num-inputs="6"
          :should-auto-focus="true"
          :is-input-num="true"
          @on-complete="smartStepSaveOTP"
          :key="otpKey"
        />
      </div>
      <div v-if="smartStep === 'PASSWORD'">
        <h1 class="mb-2 font-bold">Enter Your Password</h1>
        <div class="flex items-center gap-2 mb-6">
          <feather-icon
            icon="ArrowLeftCircleIcon"
            svgClasses="h-5 w-5 cursor-pointer"
            @click="
              smartStep = 'PHONE';
              password = '';
            "
          />
          <p>{{ email }}</p>
        </div>
        <vs-input
          v-model="password"
          v-validate="'required|min:6'"
          class="w-full bg-light mt-10"
          data-vv-validate-on="blur"
          icon="icon icon-lock"
          icon-no-border
          icon-pack="feather"
          label-placeholder="Password"
          name="password"
          type="password"
          color="white"
          @keyup.enter="submitLoginRequest(otpCode)"
        />
        <span class="text-danger text-sm font-bold">{{ errors.first('password') }}</span>

        <div class="flex flex-wrap justify-end mt-10">
          <vs-button :disabled="!validatePassword || disable" @click="submitLoginRequest(otpCode)" type="border" color="primary"
            >Sign In</vs-button
          >
        </div>
      </div>
    </div>
    <!---
      <div class="flex flex-wrap justify-between my-5">
      <router-link to="/forgot-password">Forgot Password?</router-link>
    </div>--->

    <!--    <vs-divider>or</vs-divider>-->
    <!--    <div class="flex flex-wrap justify-between mb-3">-->
    <!--      <vs-button @click="loginGoogle">Sign-in with Google</vs-button>-->
    <!--      <vs-button disabled>Sign-in with Github</vs-button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import jwt from '../../services/jwt';
import OtpInput from '@bachdgvn/vue-otp-input';

export default {
  data() {
    return {
      email: '',
      currentStep: 'EMAIL',

      smartStep: 'PHONE',
      otpCode: '',

      loginMethods: [],
      selectedMethod: '',

      loginToken: '',

      password: '',

      disable: false,
      otpKey: 0,

      sound: null,
    };
  },
  computed: {
    validateEmail() {
      return !this.errors.first('email') && this.email !== '';
    },
    validatePassword() {
      return !this.errors.first('email') && this.password !== '';
    },
  },
  components: {
    OtpInput,
  },
  watch: {
    disable(newVal) {
      if (newVal === true) {
        this.disableInputs();
      } else {
        this.enableInputs();
      }
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });

        return false;
      }
      return true;
    },
    checkLoginMethods() {
      if (!this.checkLogin()) return;

      this.disable = true;

      jwt
        .getLoginMethods(this.email, 'ipdev')
        .then((response) => {
          this.disable = false;

          this.loginMethods = [];

          Object.entries(response.data).forEach((entry) => {
            const [key, value] = entry;

            if (value === true) {
              this.loginMethods.push(key);
            }
          });

          if (this.loginMethods.includes('SMART')) {
            this.smartStep = 'PHONE';
            return this.createLoginRequest(this.loginMethods[0]);
          }

          if (this.loginMethods.length === 1) {
            return this.createLoginRequest(this.loginMethods[0]);
          }

          this.currentStep = 'METHOD';
        })
        .catch((exception) => {
          this.disable = false;
          return this.$vs.notify({
            title: 'Failed to login',
            text: exception.response.data.message,
            iconPack: 'feather',
            icon: 'icon-user-x',
            position: 'top-center',
            color: 'danger',
          });
        });
    },
    createLoginRequest(method) {
      if (!this.checkLogin()) return;

      jwt
        .createLoginRequest(this.email, method, 'ipdev')
        .then((response) => {
          this.selectedMethod = response.data.method;
          this.currentStep = `CHALLENGE_${response.data.method}`;
          this.loginToken = response.data.loginToken;
        })
        .catch((exception) => {
          console.dir(exception);
          return this.$vs.notify({
            title: 'Failed to login',
            text: exception.response.data.message,
            iconPack: 'feather',
            icon: 'icon-user-x',
            position: 'top-center',
            color: 'danger',
          });
        });
    },
    disableInputs() {
      // Add the 'disabled' class to all elements with class 'otp-input'
      const elements = document.querySelectorAll('.otp-input');
      elements.forEach((element) => {
        element.disabled = true;
        element.classList.add('disabled-otp');
      });
    },
    enableInputs() {
      // Remove the 'disabled' class from all elements with class 'otp-input'
      const elements = document.querySelectorAll('.otp-input');
      elements.forEach((element) => {
        element.disabled = false;
        element.classList.remove('disabled-otp');
      });
      this.otpKey++;
    },
    async submitLoginRequest(otpCode = null) {
      if (!this.checkLogin()) return;

      this.disable = true;
      const payload = {
        loginToken: this.loginToken,
        turnstileToken: 'ipdev',
        password: this.selectedMethod === 'PASSWORD' || this.selectedMethod === 'SMART' ? this.password : null,
        challengeCode:
          this.selectedMethod === 'EMAIL' || this.selectedMethod === 'PHONE' || this.selectedMethod === 'SMART' ? otpCode : null,
      };

      this.$store
        .dispatch('auth/loginJWT', payload)
        .then(() => {
          // this.sound.play()
          this.disable = false;
        })
        .catch((exception) => {
          console.dir(exception);
          this.disable = false;

          let title = 'Failed to login';

          if (exception.response.data.type === 'UNABLE_TO_LOGIN') {
            title = 'Too many password attempts';
            this.currentStep = 'EMAIL';
            this.email = '';
            this.password = '';
          }

          if (exception.response.data.type === 'CHALLENGE_FAILED') {
            title = 'Too many code attempts';
            this.currentStep = 'EMAIL';
            this.email = '';
            this.password = '';
          }

          return this.$vs.notify({
            title,
            text: exception.response.data.message,
            iconPack: 'feather',
            icon: 'icon-user-x',
            position: 'top-center',
            color: 'danger',
          });
        });
    },

    smartStepSaveOTP(otpCode) {
      this.otpCode = otpCode;
      this.smartStep = 'PASSWORD';
    },
    registerUser() {
      this.$router.push('/register');
    },
  },
  mounted() {
    /* gapi.auth2.init({
      client_id: '433562971754-mcd0svkbb4d12ee1c35i3kq4jdhhbvtp.apps.googleusercontent.com',
    }); */
    this.sound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Login_Success.mp3');
  },
};
</script>

<style lang="scss">
#LoginPage {
  .otp-input {
    width: 50px;
    height: 65px;
    padding: 10px;
    //margin-right: 20px;
    font-size: 20px;
    border-radius: 7px;
    font-family: 'Space Grotesk', sans-serif;
    border: 2px solid rgb(255 255 255 / 100%);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
  }

  .disabled-otp {
    border: 2px solid rgb(255 255 255 / 15%);
    background: #0d0d0d8e;
  }

  @media screen and (max-width: 576px) {
    .otp-input {
      width: 40px; /* Adjust width */
      height: 50px; /* Adjust height */
    }
  }

  .otp-input-box span {
    display: none;
  }

  .vs-input--input {
    border: 1px solid #222f44 !important;
    border-radius: 5px;
  }

  .card-hover-mode {
    &:hover {
      // transform: translateY(-3px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
      border: 1px #0053ff solid;
    }
  }
}
</style>
